import { marked } from 'marked';
import sanitizeHtml from 'sanitize-html';

const ALLOWED_SANDBOX_TOKENS = [
  'allow-scripts',
  'allow-same-origin',
  'allow-popups',
  'allow-popups-to-escape-sandbox',
  'allow-forms',
  'allow-presentation',
];

/**
 * Converts raw input (HTML or Markdown) into sanitized HTML.
 */
export function parseWysiwygInput(input: string, isMarkdown = false): string {
  const rawHtml = isMarkdown ? (marked.parse(input) as string) : input;

  return sanitizeHtml(rawHtml, {
    allowedTags: [
      'p',
      'a',
      'img',
      'ul',
      'ol',
      'li',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'strong',
      'em',
      'u',
      's',
      'iframe',
      'br',
      'hr',
      'div',
      'span',
    ],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
      img: ['src', 'alt', 'title', 'width', 'height'],
      iframe: [
        'src',
        'width',
        'height',
        'frameborder',
        'allow',
        'allowfullscreen',
        'title',
        'loading',
        'referrerpolicy',
        { name: 'sandbox', multiple: true, values: ALLOWED_SANDBOX_TOKENS },
        'data-aspect-ratio',
      ],
      '*': ['class', 'style'],
    },
    allowedStyles: {
      '*': {
        // Keep alignment coming from CMS styles like "text-align:center".
        'text-align': [/^left$/i, /^right$/i, /^center$/i, /^justify$/i],
      },
    },
    allowVulnerableTags: true,
  });
}
